import { ethers } from 'ethers';
import { USDT_DECIMALS } from '../config/contracts';

// BigNumber (wei) -> human USDT string
export function fromUSDT(value, maxDp = 2) {
  try {
    const s = ethers.utils.formatUnits(value || 0, USDT_DECIMALS);
    const n = parseFloat(s);
    if (Number.isNaN(n)) return '0';
    return trim(n, maxDp);
  } catch {
    return '0';
  }
}

// human number/string -> BigNumber (wei)
export function toUSDT(amount) {
  return ethers.utils.parseUnits(String(amount), USDT_DECIMALS);
}

// BigNumber (wei) -> plain JS Number (for charts/maths)
export function numUSDT(value) {
  try {
    return parseFloat(ethers.utils.formatUnits(value || 0, USDT_DECIMALS)) || 0;
  } catch {
    return 0;
  }
}

function trim(n, dp) {
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: dp,
  });
}

// Pretty money with $ prefix
export function usd(value, maxDp = 2) {
  return '$' + fromUSDT(value, maxDp);
}

// 0x1234...abcd
export function shortAddr(addr) {
  if (!addr) return '';
  return addr.slice(0, 6) + '...' + addr.slice(-4);
}

// unix seconds -> readable date
export function fmtDate(ts) {
  const n = Number(ts) * 1000;
  if (!n) return '-';
  return new Date(n).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const ACTIVITY_LABELS = {
  0: 'Registration',
  1: 'Package Upgrade',
  2: 'Sponsor Income',
  3: 'Level Income',
  4: 'Silver Pool',
  5: 'Gold Pool',
  6: 'Diamond Pool',
  7: 'Special Pool',
  8: 'Withdrawal',
  9: 'Re-Topup',
  10: 'All Packages',
};

export function activityLabel(type) {
  return ACTIVITY_LABELS[Number(type)] || 'Activity';
}
